import React from "react";
import "../App.css";
import windows from "../images/windows-toets.svg";
import plus from "../images/plus-toets.svg";
import L from "../images/L-toets.svg";
import arrow from "../images/arrow_icon.png";

function scrollIntoView() {
    document.getElementById("secondScreen").scrollIntoView();
}

const FirstScreen = () => {
    return (
        <div className="fs">
            <div className="fs-title">
                <h1>Vergrendel je scherm voortaan met ...</h1>
            </div>
            <div className="fs-images">
                <img
                    src={windows}
                    alt="windowstoets"
                    className="windows-icon"
                />
                <img src={plus} alt="plusteken" className="plus-icon" />
                <img src={L} alt="Ltoets" className="l-icon" />
            </div>
            <div className="fs-button">
                <button onClick={scrollIntoView}>
                    <img src={arrow} alt="windowstoets" className="arrow-img" />
                </button>
            </div>
        </div>
    );
};

export default FirstScreen;
